import { Card, Col, Row, Form, Typography, Flex, Button } from "antd";
import useFetch from "../../hooks/useFetch";
import { useEffect, useState, useContext } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import BillingFilter from "../../components/reports/BillingFilter";
import { IndexContext } from "../../context/IndexContext";
import dayjs from "dayjs";
import DataTable from "../../components/common/DataTable";

var isoWeek = require("dayjs/plugin/isoWeek");
const { Title } = Typography;

dayjs.extend(isoWeek);

export default function BillingReportPage() {
  const { siteSelected, notificationApi } = useContext(IndexContext);

  const [fetchWrapper] = useFetch();

  const [filterForm] = Form.useForm();
  const [filterValues, setFilterValues] = useState(null);
  const [chargeData, setChargeData] = useState([]);

  const applyFilter = (value) => {
    setFilterValues(value);
  };

  function downloadReportData() {
    fetchWrapper({
      endpoint_url: "reports/downloadBillingReportData",
      method: "POST",
      json_output: false,
      body: {
        report_data: chargeData,
      },

      onSuccess: (response) => {
        if (response.headers.get("content-type") !== "application/json") {
          // no issue with the response. returned a spreadsheet
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Billing_Report_${dayjs().format(
              "YYYYMMDD_HHmmss"
            )}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
          });
        }
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: "Failed to download file",
        });
      },
    });
  }

  const columns_charge = [
    {
      title: "Charge Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Charge Amount",
      dataIndex: "amount",
      key: "amount",
    },
  ];

  function getBillingReport(filter) {
    fetchWrapper({
      endpoint_url: "reports/getBillingData",
      body: {
        selected_month: filter,
        site_id: siteSelected,
      },
      onSuccess: (response) => {
        setChargeData(response.data.charge_data);
      },
    });
  }

  useEffect(() => {
    if (filterValues && siteSelected) {
      setChargeData([]);
      getBillingReport(dayjs(filterValues.month.$d).format("YYYY-MM"));
    }
  }, [filterValues, siteSelected]);

  return (
    <>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <BillingFilter form={filterForm} applyFilter={applyFilter} />
        </Col>
        <Col span={24}>
          <Card styles={{ body: { minHeight: 400 } }}>
            <Flex
              justify="space-between"
              align="center"
              className="mb-2"
              wrap={true}
              gap={8}
            >
              <Title level={5} className="m-0">
                Billing Report
              </Title>
              <Button
                icon={<DownloadOutlined />}
                onClick={() => {
                  if (chargeData.length === 0) {
                    notificationApi.error({
                      message: "No data to download",
                    });
                  } else {
                    downloadReportData();
                  }
                }}
              ></Button>
            </Flex>
            <DataTable
              size="small"
              table_column={columns_charge}
              table_data={chargeData}
              scroll_width={700}
              tableWrapperViewportHeight={0.5}
              defaultPageSize={10}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
}
